import React, { useEffect, useState } from 'react';
import { Button, Box, FormControl, Select, MenuItem, Dialog, DialogActions, DialogTitle, DialogContent, TextField, Checkbox, Autocomplete, Chip, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Notification_Platforms } from '../../../utility';
import { ArrowForwardIos, Brightness5Outlined, CloseOutlined } from '@mui/icons-material';
import { vendorDict } from '../../../utility';
import { updateNotification } from '../../../Services';
import { toast } from 'react-toastify';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Tooltip from '@mui/material/Tooltip';

function UserNotification({ serviceEntity, notificationData, id, platformData, setPlatformData, setIsInstanceMenu }) {

    const [selectedCheckboxes, setSelectedCheckboxes] = useState({ notificationFrequency: [], eventCategoryType: [], eventImpact: [], eventAction: [], });
    const [isMainViewVisible, setisMainViewVisible] = useState(true);
    const [selectedBusinessService, setSelectedBusinessService] = useState([]);
    const [selectedNotificationSource, setSelectedNotificationSource] = useState([]);
    const [notificationServices, setNotificationServices] = useState([]);
    const [checkboxError, setCheckboxError] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editingIndex, setEditingIndex] = useState(-1);
    const [notifications, setNotifications] = useState([]);
    const [notificationToDelete, setNotificationToDelete] = useState(null);
    const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
    const [notificationTitle, setNotificationTitle] = useState('');  
    const [showErrors, setShowErrors] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [sourceInputText, setSourceInputText] = useState("");
    const [serviceInputText, setServiceInputText] = useState("");
    const reverseVendorDict = Object.fromEntries(
        Object.entries(vendorDict).map(([label, value]) => [value, label])
    );

    const handleNotificationSourceChange = (newValue) => {
        setSelectedNotificationSource(newValue);
        const validServices = newValue.flatMap((source) => serviceEntity[source] || []);
        const updatedBusinessServices = selectedBusinessService.filter((service) =>
            validServices.includes(service)
        );
        setSelectedBusinessService(updatedBusinessServices);
        loadServicesForNotificationSource(newValue);
    };
    
    const loadServicesForNotificationSource = (sources) => {
        const sourceList = Array.isArray(sources) ? sources : [sources];
    
        if (sourceList.length > 0) {
            const allServices = sourceList.flatMap((source) => serviceEntity[source] || []);
            const uniqueSorted = [...new Set(allServices)].sort();
            setNotificationServices(uniqueSorted);
        } else {
            setNotificationServices([]);
        }
    };    

    const handleDeleteNotification = (notificationId) => {
        const payload = {
            user_id: id,
            notifications: {
                instance_id: notificationId
            }
        };
        updateNotification(payload);
        setNotifications((prevNotifications) =>
            prevNotifications.filter((notification) => notification.instance_id !== notificationId)
        );
    };


    const handleDeleteButtonClick = (notificationId) => {
        setNotificationToDelete(notificationId);
        setShowConfirmDeleteModal(true);
    };

    const handleSelectPlatform = (event) => {
        setPlatformData(event.target.value);
    };

    const handleToggleCreateButtonClick = () => {
        setShowErrors(false);
        setIsEditMode(false);
        setEditingIndex(-1);
        setSelectedNotificationSource([]);
        setSelectedBusinessService([]);
        setSelectedCheckboxes({ notificationFrequency: [], eventCategoryType: [], eventImpact: [], eventAction: [], });
        setNotificationTitle('');
        setisMainViewVisible(!isMainViewVisible);
        setIsInstanceMenu(isMainViewVisible);
    };

    const handleTitleChange = (event) => {
        setNotificationTitle(event.target.value);
    };

    const buildUpdateNotificationPayload = () => {
        const shortNameSources = selectedNotificationSource.map(
            (label) => vendorDict[label] || label
        );
    
        // Add instance_id when in edit mode
        const notificationPayload = {
            user_id: id,
            notifications: {
                instance_name: notificationTitle || "NotificationInstance",
                sources: shortNameSources,
                services: selectedBusinessService,
                settings: {
                    Notification: selectedCheckboxes.notificationFrequency,
                    ReleaseType: selectedCheckboxes.eventCategoryType,
                    Impact: selectedCheckboxes.eventImpact,
                    Action: selectedCheckboxes.eventAction.length > 0
                        ? selectedCheckboxes.eventAction.map(action =>
                            action === "No Action Required" ? "Without Action" : "With Action"
                        )
                        : [],
                },
            },
        };
    
        if (isEditMode && editingIndex !== -1) {
            const existingNotification = notifications[editingIndex];
            if (existingNotification && existingNotification.instance_id) {
                notificationPayload.notifications.instance_id = existingNotification.instance_id;
            }
        }
    
        return notificationPayload;
    };
          

    const RequiredLabel = ({ text }) => (
        <span>
          {text} <span className="text-danger">*</span>
        </span>
      );
      
      const handleAddButtonClick = () => {
        setShowErrors(true);
      
        const isTitleMissing = !notificationTitle.trim();
        const isSourceMissing = !selectedNotificationSource?.length;
        const isServiceMissing = !selectedBusinessService?.length;
        const isCheckboxMissing =
            !selectedCheckboxes.notificationFrequency.length ||
            !selectedCheckboxes.eventCategoryType.length;
      
        if (isTitleMissing || isSourceMissing || isServiceMissing || isCheckboxMissing) {
            toast.error("Please fill all the required fields.", {
                toastId: "combined-error",
            });
            return;
        }
    
        const newNotification = {
            title: notificationTitle,
            source: selectedNotificationSource,
            businessService: selectedBusinessService,
            frequency: selectedCheckboxes.notificationFrequency,
            eventCategoryType: selectedCheckboxes.eventCategoryType,
            eventImpact: selectedCheckboxes.eventImpact,
            eventAction: selectedCheckboxes.eventAction,
        };
    
        const payload = buildUpdateNotificationPayload();
        setIsLoading(true);
    
        updateNotification(payload)
            .then((response) => {
                if (response.status === "success") {
                    const instanceId = response.instance_id;
                    
                    if (isEditMode) {
                        const updatedNotifications = [...notifications];
                        updatedNotifications[editingIndex] = {
                            ...newNotification,
                            instance_id: instanceId,
                        };
                        setNotifications(updatedNotifications);
                    } else {
                        setNotifications((prev) => [
                            ...prev,
                            { ...newNotification, instance_id: instanceId },
                        ]);
                    }
    
                    toast.success("Notification saved successfully!");

                    setisMainViewVisible(true);
                    setIsEditMode(false);
                    setEditingIndex(-1);
                    setSelectedNotificationSource([]);
                    setSelectedBusinessService([]);
                    setSelectedCheckboxes({
                        notificationFrequency: [],
                        eventCategoryType: [],
                        eventImpact: [],
                        eventAction: [],
                    });
                    setNotificationServices([]);
                    setNotificationTitle('');
                    setIsInstanceMenu(false);
                } else {
                    toast.error("Failed to save the notification. Please try again.");
                }
            })
            .catch((error) => {
                console.error("Error saving notification:", error);
                toast.error("Failed to save the notification. Please try again.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };
    

    const handleEditButtonClick = (index) => {
        setShowErrors(false);

        setIsInstanceMenu(true);

        const notificationToEdit = notifications[index];

        const businessServiceArray = Array.isArray(notificationToEdit.businessService)
            ? notificationToEdit.businessService
            : notificationToEdit.businessService
                ? [notificationToEdit.businessService]
                : [];

        const sourceArray = Array.isArray(notificationToEdit.source)
            ? notificationToEdit.source
            : notificationToEdit.source
                ? [notificationToEdit.source]
                : [];

        loadServicesForNotificationSource(sourceArray);
        setSelectedNotificationSource(sourceArray);
        setSelectedBusinessService(businessServiceArray);
        setSelectedCheckboxes({
            notificationFrequency: Array.isArray(notificationToEdit.frequency)
                ? notificationToEdit.frequency
                : notificationToEdit.frequency
                    ? [notificationToEdit.frequency]
                    : [],
            eventCategoryType: Array.isArray(notificationToEdit.eventCategoryType)
                ? notificationToEdit.eventCategoryType
                : notificationToEdit.eventCategoryType
                    ? [notificationToEdit.eventCategoryType]
                    : [],
            eventImpact: Array.isArray(notificationToEdit.eventImpact)
                ? notificationToEdit.eventImpact
                : notificationToEdit.eventImpact
                    ? [notificationToEdit.eventImpact]
                    : [],
            eventAction: Array.isArray(notificationToEdit.eventAction)
                ? notificationToEdit.eventAction
                : notificationToEdit.eventAction
                    ? [notificationToEdit.eventAction]
                    : [],
        });

        setNotificationTitle(notificationToEdit.title);
        setisMainViewVisible(false);
        setIsEditMode(true);
        setEditingIndex(index);
    };

    const handleRemoveSource = (sourceToRemove) => {
        const updatedSources = selectedNotificationSource.filter(source => source !== sourceToRemove);
        setSelectedNotificationSource(updatedSources);
    
        // Remove services that belonged to the removed source
        const validServices = updatedSources.flatMap(source => serviceEntity[source] || []);
        const filteredServices = selectedBusinessService.filter(service => validServices.includes(service));
        setSelectedBusinessService(filteredServices);
    
        // Also update the service list
        loadServicesForNotificationSource(updatedSources);
    };
    
    const handleRemoveBusinessService = (serviceToRemove) => {
        setSelectedBusinessService((prevSelectedServices) =>
            prevSelectedServices.filter((service) => service !== serviceToRemove)
        );

        selectedBusinessService.forEach((businessService) => {
            if (businessService === serviceToRemove) {
                setSelectedNotificationSource((prevSelectedServices) =>
                    prevSelectedServices.filter((service) => service !== businessService.source)
                );
            }
        });
    };
    const handleCheckboxChange = (section, value) => {
        setSelectedCheckboxes((prev) => {
            const updatedSection = Array.isArray(prev[section]) ? prev[section] : [];
            const updatedValues = updatedSection.includes(value)
                ? updatedSection.filter((item) => item !== value)
                : [...updatedSection, value];

            const isSelected = updatedValues.length > 0;

            if (isSelected) {
                setCheckboxError(null);
            }

            return {
                ...prev,
                [section]: updatedValues,
            };
        });
    };
    const isNotificationIncomplete = (notification) => {
            return (
                !notification.title ||
                !notification.source || notification.source.length === 0 ||
                !notification.businessService || notification.businessService.length === 0 ||
                !notification.frequency || notification.frequency.length === 0 ||
                !notification.eventCategoryType || notification.eventCategoryType.length === 0
            );
        };

    const getFormattedCheckboxValues = () => {
        const combinedValues = [
            ...selectedCheckboxes.notificationFrequency,
            ...selectedCheckboxes.eventCategoryType,
            ...selectedBusinessService.map((service) => service.label),
            ...(Array.isArray(selectedNotificationSource) ? selectedNotificationSource.map((service) => typeof service === 'object' ? service.label : service) : []),
        ].filter(Boolean);

        let formattedNotificationFrequency = '';
        const formattedSource = selectedNotificationSource;
        const formattedBusinessServices = [...selectedBusinessService];
        const formattedEventCategoryType = selectedCheckboxes.eventCategoryType.join(', ');

        if (selectedCheckboxes.notificationFrequency.length > 0) {
            formattedNotificationFrequency = selectedCheckboxes.notificationFrequency.join(', ');
        }

        let combinedFormattedValue = (formattedNotificationFrequency || formattedEventCategoryType || formattedBusinessServices) 
        ? `${formattedNotificationFrequency} ${formattedEventCategoryType} Alert - ${formattedBusinessServices}`
        : "";    

        return {
            formattedNotificationFrequency,
            formattedSource,
            formattedBusinessServices,
            formattedEventCategoryType,
            combinedFormattedValue,
        };
    };

    useEffect(() => {
        if (notificationData && notificationData.length > 0) {
            const tempNotifications = notificationData.map((item) => {
                return {
                    title: item.instance_name,
                    instance_id: item.instance_id,
                    source: (item.sources || []).map(
                        (shortName) => reverseVendorDict[shortName] || shortName
                    ),
                    businessService: item.services || [],
                    frequency: item.settings.Notification,
                    eventCategoryType: item.settings.ReleaseType,
                    eventImpact: item.settings.Impact,
                    eventAction: Array.isArray(item.settings.Action)
                                ? item.settings.Action.map((action) => 
                                    action === 'Without Action' ? 'No Action Required' : 
                                    action === 'With Action' ? 'Action Required' : 
                                    action
                                )
                                : []
                };
            });
    
            setNotifications(tempNotifications);
        }
    }, [notificationData]);    

    return (
        <>
            <Box
                sx={{
                    padding: '10px 20px',
                    top: 0,
                    left: '280px',
                }}
                className='text-body-1 position-absolute d-flex align-items-center'
            >
                <div className={isMainViewVisible ? 'font-900' : ''}>Notifications</div>
                {!isMainViewVisible && <div className='d-flex align-items-center font-900'>
                    <ArrowForwardIos className='text-secondary mx-2' fontSize='18' />
                    {isEditMode ? (
                        <span>Manage Notification - {notificationTitle || 'Untitled'}</span>
                        ) : (
                        <span>Create New Notification</span>
                    )}
                </div>}
            </Box>
            {isMainViewVisible ? (
                <div className="mb-3" style={{ width: '750px' }}>
                    {/* new code */}
                    <div className='d-flex align-items-center mb-2'>
                        <p className='m-0 font-900'>Configure Notifications</p>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <div style={{ flex: 1, marginBottom: '20px' }}>
                            <div className="card">
                                {/* Card */}
                                <div className="card-body d-flex justify-content-between align-items-center py-3 px-4">
                                    <div>
                                        <p className="m-0 font-weight-bold text-sm font-weight-bold">Notification Platform Preference</p>
                                        <small className="text-secondary text-s">Select your preferred platform to get notified with the latest updates.</small>
                                    </div>
                                    <FormControl sx={{ width: 200 }}>
                                        <Select
                                            value={platformData}
                                            onChange={handleSelectPlatform}
                                            defaultValue="email"
                                            displayEmpty
                                            sx={{
                                                fontSize: '0.8125rem',
                                                height: '36px',
                                            }}
                                        >
                                            {Object.keys(Notification_Platforms).map((item) => (
                                                <MenuItem key={item} value={item} disabled={!Notification_Platforms[item]['isActive']}>
                                                    <Box className="text-body-sm" sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <img
                                                            src={Notification_Platforms[item]['logo']}
                                                            alt={item}
                                                            style={{ width: '15px', marginRight: '12px' }}
                                                        />
                                                        {Notification_Platforms[item]['title']}
                                                    </Box>
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>

                        </div>
                    </div>

                    <p className='m-0 font-900'>Create your own notifications</p>
                    <small className="text-secondary text-sm">Select your preferred platform to get notified with the latest updates.</small>
                    <div className='mt-2'>
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={handleToggleCreateButtonClick}
                            className='d-flex align-items-center'
                            sx={{
                                textTransform: 'none', fontWeight: 'bold',
                                padding: '2px 15px', fontSize: '14px', minWidth: '100px',
                                boxShadow: 2
                            }}
                            disabled={notifications.length >= 5}>
                            <AddIcon sx={{ fontSize: 18, marginRight: 1 }} />
                            <span>Create</span>
                        </Button>
                    </div>

                    {/* Display note when max notifications are reached */}
                    {notifications.length >= 5 && (
                        <div className="d-flex align-items-center mt-3">
                            <InfoIcon sx={{ fontSize: 20, marginRight: 1 }} />
                            <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
                                You have reached the maximum number of notifications.
                            </span>
                        </div>
                    )}


                    {/* Notification Card */}
                    {notifications.slice(0, 5).map((notification, index) => (
                        <div key={notification.id} className={`card mt-3 p-1 mb-1 ${isNotificationIncomplete(notification) ? 'border-danger' : 'border-secondary'}`}>
                            <div className="card-body p-2">
                                <div className="d-flex align-items-start w-100">
                                    {/* Numbered Badge */}
                                    <Brightness5Outlined className='text-dark' style={{
                                        position: 'absolute',
                                        top: '8px',
                                        left: '10px',
                                        fontSize: '28px',
                                    }} />
                                    <div
                                        className="d-flex justify-content-center align-items-center rounded-circle bg-dark text-white"
                                        style={{
                                            minWidth: '20px',
                                            height: '20px',
                                            fontSize: '14px',
                                            position: 'relative',
                                            fontWeight: 'bold',
                                            marginRight: '4px',
                                            marginLeft: '12px',
                                            transform: 'translateX(-50%)',
                                        }}
                                    >
                                        {index + 1} {/* Dynamic numbering based on the notification's index */}
                                    </div>

                                    {/* Notification Content */}
                                    <div className="flex-grow-1">
                                    <h6 className="font-weight-bold mb-0 d-flex align-items-center" style={{ fontSize: '12px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '400px', wordWrap: 'break-word' }}>
                                        {notification.title || 'NA'}

                                        {isNotificationIncomplete(notification) && (
                                            <Tooltip title="Please fill all the required fields." arrow placement="top">
                                                <ErrorOutlineIcon
                                                    sx={{
                                                    fontSize: '16px',
                                                    color: 'red',
                                                    marginLeft: '6px',
                                                    cursor: 'pointer',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    }}
                                                />
                                            </Tooltip>
                                            )}
                                        </h6>
                                        <p className="text-secondary mb-0" style={{ fontSize: '12px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '400px', wordWrap: 'break-word', }}>
                                            <strong>Sources:</strong> {notification.source && notification.source.length > 0 ? notification.source.join(', ') : 'Business source not selected'}
                                        </p>
                                        <p className="text-secondary mb-0" style={{ fontSize: '12px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '400px', wordWrap: 'break-word', }}>
                                            <strong>Business Services:</strong> {notification.businessService && notification.businessService.length > 0 ? notification.businessService.join(', ') : 'Business service not selected'}
                                        </p>
                                    </div>
                                    {/* Manage Button */}
                                    <div className="d-inline-flex">
                                        <IconButton
                                            onClick={() => handleEditButtonClick(index)}
                                            aria-label="Edit"
                                            size="small"
                                        >
                                            <EditIcon fontSize="small"/>
                                        </IconButton>
                                        <IconButton
                                            onClick={() => handleDeleteButtonClick(notification.instance_id)}
                                            aria-label="Delete"
                                            size="small"
                                            color="secondary"
                                        >
                                            <DeleteIcon fontSize="small"/>
                                        </IconButton>
                                    </div>
                                </div>
                            </div>
                        </div>

                    ))}

                    <Dialog
                        open={showConfirmDeleteModal}
                        onClose={() => setShowConfirmDeleteModal(false)}
                    >
                        <DialogTitle>Confirm Deletion</DialogTitle>
                        <DialogContent sx={{ color: 'black' }}>
                            <p>Are you sure you want to delete this notification?</p>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setShowConfirmDeleteModal(false)} sx={{ color: 'black', '&:hover': { backgroundColor: '#f0f0f0', } }}>
                                Cancel
                            </Button>
                            <Button
                                onClick={() => {
                                    handleDeleteNotification(notificationToDelete);
                                    setShowConfirmDeleteModal(false);
                                }}
                                sx={{
                                    color: 'white',
                                    backgroundColor: 'red',
                                    '&:hover': {
                                        backgroundColor: '#d32f2f',
                                    }
                                }}
                            >
                                Confirm
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            ) : (
                <div style={{ maxHeight: "500px" }}>
                    <p className='font-900 mb-2'>Add New Notification Details</p>
                    <div className="card" style={{ width: '800px' }}>
                        <div className="card-body px-4">
                            <TextField
                                size="small"
                                variant="standard"
                                label={
                                    <span style={{ fontSize: '13px' }}>
                                         <RequiredLabel text="Notification Title" />
                                    </span>
                                  }
                                value={notificationTitle}
                                onChange={handleTitleChange}
                                fullWidth
                                sx={{
                                    input: { fontSize: '13px' },
                                    '& .MuiInputBase-root': {
                                        paddingTop: '6px',
                                      },
                                      '& .MuiInput-underline:before': {
                                        borderBottomColor: showErrors && !notificationTitle.trim() ? '#dc3545' : undefined,
                                      },
                                      '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                                        borderBottomColor: showErrors && !notificationTitle.trim() ? '#dc3545' : undefined,
                                      },
                                }}
                            />
                            {/* Sources */}
                            <div className='mt-3 pb-12 border-bottom'>
                                <div className="d-flex">
                                    <div>
                                    <p className="m-0 font-weight-bold text-sm">
                                        <RequiredLabel text="Sources" />
                                    </p>

                                        <small className="text-secondary text-lite">
                                            Select the list of sources you want to include in this notification instance.
                                        </small>
                                    </div>

                                    {/* Source - Autocomplete Searchable Dropdown */}
                                    <div className="ml-auto mb-1" style={{ minWidth: '250px' }}>
                                        <Autocomplete
                                            inputValue={sourceInputText}
                                            onInputChange={(_, value, reason) => {
                                                if (reason === "reset") return;
                                                setSourceInputText(value);
                                            }}
                                            multiple
                                            id="notification-source-autocomplete"
                                            options={Object.keys(serviceEntity)}
                                            value={selectedNotificationSource}
                                            disableClearable
                                            disableCloseOnSelect
                                            onChange={(event, newValue, reason) => {
                                                if (reason === 'removeOption' && sourceInputText === "" && event?.type === 'keydown') {
                                                    return;
                                                }
                                                handleNotificationSourceChange(newValue);
                                            }}
                                            onClose={() => {
                                                setSourceInputText("");
                                            }}
                                            getOptionLabel={(option) => option}
                                            renderOption={(props, option, { selected }) => (
                                                <li {...props}>
                                                    <Checkbox
                                                        size='small'
                                                        style={{ marginRight: 6 }}
                                                        checked={selected}
                                                    />
                                                    <span className='text-sm'>{option}</span>
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Select Sources"
                                                    variant="outlined"
                                                    size="small"
                                                    error={showErrors && selectedNotificationSource.length === 0}
                                                    sx={{
                                                        fontSize: '0.75rem',
                                                        '& .MuiOutlinedInput-root': {
                                                        '& input': {
                                                            fontSize: '0.80rem',
                                                        },
                                                        },
                                                    }}
                                                />
                                            )}
                                            renderTags={() => null}
                                            sx={{
                                                '& .MuiAutocomplete-listbox': {
                                                    maxHeight: '200px',
                                                },
                                            }}
                                        />
                                    </div>
                                </div>
                                {/* Display source selection */}
                                {selectedNotificationSource && selectedNotificationSource.length > 0 && (
                                    <Box className='pt-2' sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {Array.isArray(selectedNotificationSource) &&
                                            [...selectedNotificationSource]
                                                .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
                                                .map((source, index) => (
                                                    <Chip
                                                        label={source}
                                                        key={index}
                                                        style={{ borderRadius: '4px', height: "26px", background: 'E6E6E4', fontSize: '13px' }}
                                                        onMouseDown={(event) => event.stopPropagation()}
                                                        onDelete={() => handleRemoveSource(source)}
                                                        deleteIcon={<CloseOutlined fontSize='small' style={{ marginLeft: '0px' }} />}
                                                        className="custom-chip"
                                                    />
                                                ))}
                                    </Box>
                                )}
                            </div>

                            {/* Business Service */}
                            <div className='mt-12 pb-12 border-bottom'>
                                <div className="d-flex">
                                    <div>
                                        <p className="m-0 font-weight-bold text-sm">
                                            <RequiredLabel text="Business Services" />
                                        </p>
                                        <small className="text-secondary text-lite">
                                            Select the list of Business Services you want to include in this notification instance.
                                        </small>
                                    </div>
                                    {/* Business Service - Autocomplete Searchable Dropdown */}
                                    <div className="ml-auto mb-1" style={{ minWidth: '250px' }}>
                                        <Autocomplete
                                            inputValue={serviceInputText}
                                            onInputChange={(_, value, reason) => {
                                                if (reason === "reset") return;
                                                setServiceInputText(value);
                                            }}
                                            multiple
                                            id="notification-service-autocomplete"
                                            options={notificationServices}
                                            disabled={!selectedNotificationSource}
                                            value={selectedBusinessService}
                                            disableClearable
                                            disableCloseOnSelect
                                            onChange={(event, newValue, reason) => {
                                                if (reason === 'removeOption' && sourceInputText === "" && event?.type === 'keydown') {
                                                    return;
                                                }
                                                setSelectedBusinessService(newValue);
                                            }}
                                            onClose={() => {
                                                setServiceInputText("");
                                            }}
                                            getOptionLabel={(option) => option}
                                            renderOption={(props, option, { selected }) => (
                                                <li {...props}>
                                                    <Checkbox
                                                        size='small'
                                                        style={{ marginRight: 8 }}
                                                        checked={selected}
                                                    />
                                                    <span className='text-sm'>{option}</span>
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Select Business Services"
                                                    variant="outlined"
                                                    size="small"
                                                    error={showErrors && selectedBusinessService.length === 0}
                                                    sx={{
                                                        fontSize: '0.75rem',
                                                        '& .MuiOutlinedInput-root': {
                                                        '& input': {
                                                            fontSize: '0.80rem',
                                                        },
                                                        },
                                                    }}
                                                />
                                            )}
                                            renderTags={() => null}
                                            sx={{
                                                '& .MuiAutocomplete-listbox': {
                                                    maxHeight: '200px',
                                                },
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Display business service selection */}
                                {selectedBusinessService && selectedBusinessService.length > 0 && (
                                    <Box className='pt-2' sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {[...selectedBusinessService].sort().map((service, index) => (
                                            <Chip
                                                label={service}
                                                key={index}
                                                style={{ borderRadius: '4px', height: "26px", background: 'E6E6E4', fontSize: '13px' }}
                                                onMouseDown={(event) => event.stopPropagation()}
                                                onDelete={() => handleRemoveBusinessService(service)}
                                                deleteIcon={<CloseOutlined fontSize='small' style={{ marginLeft: '0px' }} />}
                                                className="custom-chip"
                                            />
                                        ))}
                                    </Box>
                                )}
                            </div>

                            {/* Notify me when */}
                            <div className="d-flex align-items-start mt-12 pb-2 border-bottom">
                                <div style={{ width: '250px' }}>
                                    <p className="m-0 font-weight-bold text-sm">
                                        <RequiredLabel text="Notify me when" />
                                    </p>
                                    <small className="text-secondary text-lite">
                                        Select the preferred frequency.
                                    </small>
                                    {showErrors && selectedCheckboxes.notificationFrequency.length === 0 && (
                                        <div>
                                            <small className="text-danger">
                                            At least one must be selected
                                            </small>
                                        </div>
                                    )}
                                </div>

                                {/* Checkboxes with Labels Above */}
                                <div className="d-flex gap-4" style={{ display: 'flex', gap: '40px', marginLeft: '80px' }}>
                                    {['Instant', 'Daily', 'Weekly', 'Monthly'].map((item, index) => (
                                        <div key={index} className="d-flex flex-column align-items-center gap-2" style={{ width: '70px' }}>
                                            <label className="m-0 font-weight-bold text-s text-secondary mb-1" style={{ lineHeight: 1 }}>{item}</label>
                                            <Checkbox
                                                sx={{ '& .MuiSvgIcon-root': { fontSize: 20, padding: 0 } }}
                                                checked={selectedCheckboxes.notificationFrequency.includes(item)}
                                                onChange={() => handleCheckboxChange('notificationFrequency', item)}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Event Category Type */}
                            <div className="d-flex align-items-start mt-12 pb-2 border-bottom">
                                <div style={{ width: '250px' }}>
                                    <p className="m-0 font-weight-bold text-sm">
                                        <RequiredLabel text="Event Category Type" />
                                    </p>
                                    <small className="text-secondary text-lite">
                                        Notify only for selected category.
                                    </small>
                                    {showErrors && selectedCheckboxes.eventCategoryType.length === 0 && (
                                        <div>
                                            <small className="text-danger">
                                            At least one must be selected
                                            </small>
                                        </div>
                                    )}
                                </div>
                                {/* Checkboxes with Labels Above */}
                                <div className="d-flex gap-4" style={{ display: 'flex', gap: '40px', marginLeft: '80px' }}>
                                    {['Release', 'Maintenance', 'Outage'].map((item, index) => (
                                        <div key={index} className="d-flex flex-column align-items-center gap-2" style={{ width: '70px' }}>
                                            <label className="m-0 font-weight-bold text-s text-secondary mb-1" style={{ lineHeight: 1 }}>{item}</label>
                                            <Checkbox
                                                sx={{ '& .MuiSvgIcon-root': { fontSize: 20, padding: 0 } }}
                                                onChange={() => handleCheckboxChange('eventCategoryType', item)}
                                                checked={selectedCheckboxes.eventCategoryType.includes(item)}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Event Impact */}
                            <div className="d-flex align-items-center mt-12 pb-2 border-bottom">
                                <div style={{ width: '250px' }}>
                                    <h6 className="m-0" style={{ fontSize: '0.8125rem', fontWeight: 'bold' }}>
                                       Event Impact
                                    </h6>
                                    <small className="text-secondary" style={{ fontSize: '0.75rem' }}>
                                        Notify only for selected impact.
                                    </small>
                                </div>

                                {/* Checkboxes with Labels Above */}
                                <div className="d-flex gap-4" style={{ display: 'flex', gap: '40px', marginLeft: '80px' }}>
                                    {['High', 'Medium', 'Low', 'N/A'].map((item, index) => (
                                        <div key={index} className="d-flex flex-column align-items-center gap-2" style={{ width: '70px' }}>
                                            <label className="m-0 font-weight-bold text-s text-secondary mb-1" style={{ lineHeight: 1 }}>{item}</label>
                                            <Checkbox
                                                sx={{ '& .MuiSvgIcon-root': { fontSize: 20, padding: 0 } }}
                                                onChange={() => handleCheckboxChange('eventImpact', item)}
                                                checked={selectedCheckboxes.eventImpact.includes(item)}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Event Action */}
                            <div className="d-flex align-items-center mt-12">
                                <div style={{ width: '250px' }}>
                                    <h6 className="m-0" style={{ fontSize: '0.8125rem', fontWeight: 'bold' }}>
                                        Event Action
                                    </h6>
                                    <small className="text-secondary" style={{ fontSize: '0.75rem', whiteSpace: 'nowrap' }}>
                                        Notify only for selected action type.
                                    </small>
                                </div>

                                {/* Checkboxes with Labels Above */}
                                <div className="d-flex gap-4" style={{ display: 'flex', gap: '40px', marginLeft: '80px' }}>
                                    {['Action Required', 'No Action Required'].map((item, index) => (
                                        <div key={index} className="d-flex flex-column align-items-center gap-2" style={{ width: '70px' }}>
                                            <label className="m-0 font-weight-bold text-s text-secondary mb-1 text-nowrap" style={{ lineHeight: 1 }}>{item}</label>
                                            <Checkbox
                                                sx={{ '& .MuiSvgIcon-root': { fontSize: 20, padding: 0 } }}
                                                onChange={() => handleCheckboxChange('eventAction', item)}
                                                checked={selectedCheckboxes.eventAction.includes(item)}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>


                            {/* Buttons */}
                            <div className="d-flex justify-content-end">
                                <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={handleToggleCreateButtonClick}
                                    disabled={isLoading}
                                    className='d-flex align-items-center'
                                    sx={{
                                        textTransform: 'none',
                                        fontWeight: 'bold',
                                        padding: '2px 15px',
                                        fontSize: '14px',
                                        minWidth: '0px',
                                        boxShadow: 2,
                                        opacity: isLoading ? 0.7 : 1,
                                        pointerEvents: isLoading ? 'none' : 'auto',
                                    }}
                                >
                                    <ArrowBackIcon sx={{ fontSize: 18 }} />
                                </Button>
                                <Button
                                    variant="contained"
                                    size="small"
                                    onClick={handleAddButtonClick}
                                    disabled={isLoading}
                                    className='d-flex align-items-center ml-2'
                                    sx={{
                                        textTransform: 'none',
                                        fontWeight: 'bold',
                                        padding: '2px 15px',
                                        fontSize: '14px',
                                        minWidth: '0px',
                                        boxShadow: 2,
                                        opacity: isLoading ? 0.7 : 1,
                                        pointerEvents: isLoading ? 'none' : 'auto',
                                    }}
                                >
                                    {isLoading ? (
                                        <>
                                            <span style={{ marginRight: '8px' }}>Saving...</span>
                                            <div className="spinner-border spinner-border-sm text-light" role="status" style={{ width: '15px', height: '15px' }}></div>
                                        </>
                                    ) : isEditMode ? (
                                        <span>Update</span>
                                    ) : (
                                        <>
                                            <AddIcon sx={{ fontSize: 18, marginRight: 1 }} />
                                            <span>Add</span>
                                        </>
                                    )}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default UserNotification;
